(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["caraura-collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-cf-vehicle]');
  if (!select) return;
  const url = new URL(select.dataset.collectionUrl + (select.value ? '/' + select.value : ''), location.origin);
  const params = new URLSearchParams(location.search);
  params.delete('page');
  url.search = params.toString();
  location.assign(url.href);
});
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-cf-fitment]');
  if (!button) return;
  const trigger = document.querySelector('.fp-search-trigger__btn[data-action="open-search"]');
  if (trigger) trigger.click();
  else {
    const status = button.parentElement.querySelector('.cf-status');
    status.hidden = false;
    status.textContent = 'Vehicle search is currently unavailable. Contact support for a fitment check.';
  }
});
  } catch(e) { console.error(e); }
})();

})();
